import {Injectable} from '@angular/core';
import {Md5} from 'ts-md5/dist/esm/md5';
import {PaymentTransactionService} from "./payment-transaction.service";
import {PaymentTransactionRequest} from "../models/paymentTransactionRequest";
import {PaymentMethod} from "../enums/paymentMethod";
import {UserCardResponse} from "../interface/userCardResponse";
import {PaymentTransactionResponse} from "../interface/paymentTransactionResponse";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {Observable} from "rxjs";
import {WITH_COMMISSION, WITHOUT_COMMISSION} from "../constants/payment.constant";
import {DUPLICATE_MONEY_LUX_UUID_MESSAGE} from "../constants/global.constants";
import {MockupDataModel} from "../qr-copy-message/mockup-data.model";
import {SnackBarUtil} from "../qr-copy-message/snack-bar-util.service";
import {PaymentTransactionUtil} from "../utilityClass/paymentTransactionUtil";

@Injectable({
  providedIn: "root"
})
export class TelcellService {

  private readonly apiUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private snackBar: SnackBarUtil,
  ) {
  }

  initForProductBuying(amount: number, orderId: number) {
    const description: string = 'Product buying';
    const validDays = 3;
    const paymentTransactionRequest: PaymentTransactionRequest = new PaymentTransactionRequest(PaymentMethod.TELCELL, description, null, null, amount, validDays, null, 0, null, orderId, null);

    this.init(paymentTransactionRequest, false).subscribe({
      next: (htmlString: string) => {
        this.processResponse(htmlString);
      }
    });
  }

  initPayment(price: string, product: string, validDays: string, userCard: UserCardResponse, isCommissionActive: boolean, moneyLuxUuid: string | null) {
    const userCardId: string = `${userCard.cardId}-`;
    const paymentTransactionDescription: string = "Transfer money to user";
    const paymentTransactionRequest: PaymentTransactionRequest = this.preparePaymentTransactionRequest(paymentTransactionDescription, userCard, userCardId, price, validDays, moneyLuxUuid, null, product);

    this.init(paymentTransactionRequest, isCommissionActive).subscribe({
      next: (htmlString: string) => {
        this.processResponse(htmlString);
      },
      error: (error) => {
        if (error.status === 511 && error.error && error.error.message) {
          this.showSnackbar(MockupDataModel.error(DUPLICATE_MONEY_LUX_UUID_MESSAGE), SnackBarUtil.CLASSES.error);
        }
      }
    });
  }

  createNewAccount(sum: string, userCardId: string, isCommissionActive: boolean, moneyLuxUuid: string | null): Observable<string> {
    const url = `${this.apiUrl}/telcell?sum=${sum}&userCardId=${userCardId}&isCommissionActive=${isCommissionActive}`;
    return this.http.post<string>(url, moneyLuxUuid);
  }

  init(paymentTransactionRequest: PaymentTransactionRequest, isCommissionActive: boolean): Observable<string> {
    const url = `${this.apiUrl}/telcell/init?isCommissionActive=${isCommissionActive}`;
    return this.http.post(url, paymentTransactionRequest, {responseType: 'text'});
  }

  private showSnackbar(data: MockupDataModel, panelClassNames: string[]): void {
    this.snackBar.openSnackBar({
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: panelClassNames,
      data: data,
    });
  }

  private processResponse(htmlString: string) {
    document.open();
    document.write(htmlString);
    document.close();
  }

  private preparePaymentTransactionRequest(paymentTransactionDescription: string, userCard: UserCardResponse, userCardId: string, price: string, validDays: string, moneyLuxUuid: string | null, productOrderId: number | null, product: string | null) {
    return new PaymentTransactionRequest(
      PaymentMethod.TELCELL,
      paymentTransactionDescription,
      userCard.userId,
      userCardId,
      Number(price),
      Number(validDays),
      userCard.cardId,
      0,
      moneyLuxUuid,
      productOrderId,
      product
    );
  }
}
